import { render, staticRenderFns } from "./knCard.vue?vue&type=template&id=5f6f055a&"
import script from "./knCard.vue?vue&type=script&lang=js&"
export * from "./knCard.vue?vue&type=script&lang=js&"
import style0 from "./knCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "knCard.vue"
export default component.exports